import React from 'react'
import { Scrollbars } from 'react-custom-scrollbars'

import styled, { css } from 'styled-components'

const DATA_ATTR_SEPARATOR = '--';

const Container = styled.div`
  position: absolute;
  width: 180px;
  top: 7rem;
  left: 0rem;
  touch-action: auto;

  ${props =>
    !props.mobile &&
    css`
      top: 12.5rem;
    `};
`

const MenuItem = styled.div`
  cursor: pointer;
  font-size: 16px;
  line-height: 15px;
  text-align: left;
  padding: 5px 16px;
  color: rgb(240, 240, 240);
  ${props =>
    !props.mobile &&
    css`
      line-height: 15px;

      font-weight: 700;
      background: rgba(0, 151, 172, 0.05);
      -webkit-transition: background 0.5s;
      transition: background 0.5s;
      &:hover {
        background: rgb(0, 151, 172, 0.1);
        font-weight: bold;
      }
    `};

  ${props =>
    props.selected &&
    css`
      font-weight: 700;
      background: rgba(0, 151, 172, 0.05);
    `};
`

const ElementList = ({ item, sel, urlTo, close, show, mobile }) => {
  return (
    <>
      <Container mobile={mobile}>
        <Scrollbars
          style={{
            width: '180px',
            height: mobile === true ? 'calc(100vh - 10rem)' : 'calc(100vh - 15rem)',
          }}
          renderTrackVertical={props => <div {...props} className="track-vertical" />}
          renderThumbVertical={props => <div {...props} className="thumb-vertical" />}>
          {item.data.map((d, i) => (            
            <MenuItem
              data-ga-menu-item = { item.title.toLowerCase() + DATA_ATTR_SEPARATOR + d.name.toLowerCase().replace(/\s/g, '_')}
              key={'li-' + d.prefix + i}
              onClick={e => {
                urlTo('', item.type === 'cable' ? 'cable' : 'location', d.name)
                close()
              }}
              selected={d.name === sel}
              mobile={mobile}>
              {d.name}
            </MenuItem>
          ))}
        </Scrollbars>
      </Container>
    </>
  )
}

export default ElementList
